import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from "react-router-dom";
import { MrFormComponent, Spinner } from "mr_react_framework";
import { Divider } from 'antd';
import "../Login/Login.scss";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from "views/Experiences/redux";
import { forgotpasswordloadingSelector } from "../Login/selector";
import queryString from "query-string";
import MrTranslate, { useTranslate } from 'lib/MrTranslate/MrTranslate';


const getGuestJoinCodeForm = (props, joinCodeDefaultValue, mrIntl) => {
  return {
    processFormData: (dataProps, opts) => {
      console.log("dataProps", dataProps);
      console.log("opts", opts);
      // opts.values.email = opts.values.email.toLowerCase().trim()
      // trim and downcase this
      return opts.values;
    },
    schema: {
      type: "object",
      properties: {
        // email: {
        //   type: "string",
        //   format: "email",
        //   defaultValue: "sample@email.com",
        //   placeholder: "Email",
        //   className: "login-email",
        //   rules: [{
        //     required: true,
        //     message: "Please enter a valid email"
        //   }]
        // },
        name: {
          type: "string",
          // format: "email",
          // defaultValue: "sample@email.com",
          // placeholder: "Full name",
          placeholder: mrIntl("GuestJoinCode.full_name"),
          // className: "login-email",
          rules: [{
            required: true,
            // message: "Please enter your full name"
            message: mrIntl("GuestJoinCode.please_enter_your_full_name"),
          }]
        },
        join_code: {
          type: "string",
          // format: "email",
          default: joinCodeDefaultValue,
          // placeholder: "Join Code",
          placeholder: mrIntl("GuestJoinCode.join_code"),
          // className: "login-email",
          rules: [{
            required: true,
            // message: "Please enter a join code"
            message: mrIntl("GuestJoinCode.please_enter_a_join_code"),
          }]
        },
        include_s_code: {
          type: "string",
          widget: () => {
            // return "Enter student code to resume test or view results"
            return mrIntl("GuestJoinCode.enter_student_code_to_resume_test_or_view_results")
          }
        },
        s_code: {
          type: "string",
          // format: "email",
          // default: joinCodeDefaultValue,
          // placeholder: "Student code (optional)",
          placeholder: mrIntl("GuestJoinCode.student_code")
        },
      },
    }
  };
}

const GuestJoinCode = (props) => {
  
  const dispatch = useDispatch();
  const location = useLocation()
  const loading = useSelector(forgotpasswordloadingSelector)
  let joinCodeDefaultValue = ""
  const mrIntl = useTranslate()
  // const [joinCodeDefaultValue, setJoinCodeDefaultValue] = useState("")
  const [jsonForm, setJsonForm] = useState()
  const locationQueryParams = queryString.parse(location.search);

  useEffect(() => {
    if(location.search.indexOf("code") > -1){
      console.log("joinCode location.search", location.search)
      joinCodeDefaultValue = locationQueryParams.code
      // setJoinCodeDefaultValue(locationQueryParams.code)
      
    }
    let jsonFormTemp = getGuestJoinCodeForm(props, joinCodeDefaultValue, mrIntl);
    console.log("jsonFormTemp", jsonFormTemp)
    setJsonForm(jsonFormTemp)
  }, []);

  const handleSubmit = (data) => {
    // const finalData = {experience: {...data}};
    console.log( "handleSubmit", data);
    dispatch(actions.fetchWithJoinCode(data, {success: {
      showMessage: true,
      message: mrIntl("GuestJoinCode.test_found"), 
    }}))
  }
  
  const mainForm = <MrFormComponent 
    key={"mrForm"}
    {...props}
    visible={true}
    resourceForm={{form: {...jsonForm}, config: {isModal: false, visible: true}}}
    item={{}}
    loading={loading}
    // resourceName={"forgotPassword"}
    // formConfig={{actions: {submitText: "Login", showCancelBtn: false}}}
    formConfig={{actions: {submitText: mrIntl("GuestJoinCode.find_test"), showCancelBtn: false}, }}
    formProps={{
      
    }}
    
    // jsonForm={jsonForm}
    // schema={jsonForm.schema}
    handleOk={handleSubmit}
    handleSubmit={handleSubmit}
    // styleProps={styleProps}
  />;
  
  return <div className={"forgot-pass-main auth-form-container"}><h3><MrTranslate id={"GuestJoinCode.start_with_Join_code"}/></h3>
    <br></br>
    {jsonForm && mainForm}
    <Divider> {mrIntl("CommonText.or")} </Divider>
    <div class={"back-to-login-link"}>
      <Link to={"/auth/login"}><MrTranslate id={"CommonText.go_back_to_login"}/></Link>
    </div>
  </div>;
};

GuestJoinCode.defaultProps = {}

GuestJoinCode.propTypes = {}

export default GuestJoinCode;